import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Permission } from 'src/app/constants/permission.constant';
import { IBatch } from 'src/app/models/batches/batch';
import { AuthService } from 'src/app/services/auth.service';
import { BatchesService } from 'src/app/services/batches.services';

@Component({
  selector: 'app-share-batch-action',
  templateUrl: './share-batch-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ShareBatchActionComponent {
  @Input() batch!: IBatch;
  @Output() actionComplete = new EventEmitter<void>();

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private batchesService: BatchesService,
    private snackBar: MatSnackBar,
  ) {}

  onToggleShare(): void {
    if (!this.batch.id) return;

    const action$ = this.batch.isSharedWithSkyTeam
      ? this.batchesService.unShareBatch(this.batch.id)
      : this.batchesService.shareBatch(this.batch.id);

    action$.subscribe({
      next: () => {
        const msg = this.batch.isSharedWithSkyTeam
          ? 'Unshared from Sky Team'
          : 'Shared with Sky Team';
        this.snackBar.open(msg, 'close', { duration: 2000 });
        this.actionComplete.emit();
      },
      error: () => {
        this.snackBar.open('Action failed', 'close', { duration: 2000 });
      },
    });
  }
}
